import { parse } from '../../util/urlHelpers';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import axios from 'axios';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { searchListings } from '../SearchPage/SearchPage.duck';
import { apiBaseUrl, getUserListings } from '../../util/api';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const FETCH_LISTING_REQUEST = 'app/BusinessDashboardInvoicePage/FETCH_LISTING_REQUEST';
export const FETCH_LISTING_SUCCESS = 'app/BusinessDashboardInvoicePage/FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_ERROR = 'app/BusinessDashboardInvoicePage/FETCH_LISTING_ERROR';

export const WORKER_EXTRA_DETAILS_REQUEST = 'app/user/WORKER_EXTRA_DETAILS_REQUEST';
export const WORKER_EXTRA_DETAILS_SUCCESS = 'app/user/WORKER_EXTRA_DETAILS_SUCCESS';
export const WORKER_EXTRA_DETAILS_ERROR = 'app/user/WORKER_EXTRA_DETAILS_ERROR';
const initialState = {
  listing: [],
  fetchInProgress: false,
  fetchWorkersDataError: null,
  workerExtraDetailsFetchInProgress: false,
  workerExtraDetailsFetchError: null,
};

export default function BusinessDashboardInvoicePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTING_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchWorkersDataError: null,
        listing: [],
      };
    case FETCH_LISTING_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        listing: payload,

        // pagination: payload.data.meta,
      };
    }
    case FETCH_LISTING_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchWorkersDataError: payload };
    case WORKER_EXTRA_DETAILS_REQUEST:
      return {
        ...state,
        workerExtraDetailsFetchInProgress: true,
        workerExtraDetailsFetchError: null,
      };
    case WORKER_EXTRA_DETAILS_SUCCESS:
      return {
        ...state,
        workerExtraDetailsFetchInProgress: false,
      };
    case WORKER_EXTRA_DETAILS_ERROR:
      return {
        ...state,
        workerExtraDetailsFetchInProgress: false,
        workerExtraDetailsFetchError: payload,
      };
    default:
      return state;
  }
}
const fetchListingDataRequest = () => ({ type: FETCH_LISTING_REQUEST });
const fetchListingDataSuccess = response => ({
  type: FETCH_LISTING_SUCCESS,
  payload: response,
});
const fetchListingDataError = e => ({
  type: FETCH_LISTING_ERROR,
  error: true,
  payload: e,
});
export const workerExtraDetailsRequest = () => ({
  type: WORKER_EXTRA_DETAILS_REQUEST,
});

export const workerExtraDetailsSuccess = () => ({
  type: WORKER_EXTRA_DETAILS_SUCCESS,
});

export const workerExtraDetailsError = e => ({
  type: WORKER_EXTRA_DETAILS_ERROR,
  error: true,
  payload: e,
});
const fetchUserListing = async userId => {
  let page = 1,
    totalPages = 1;
  let resp;
  try {
    for (; page <= totalPages; page++) {
      const tempResp = await getUserListings(userId, page);
      if (!resp) {
        resp = tempResp;
      } else if (resp && resp.data && resp.data.data && Array.isArray(resp.data.data)) {
        resp.data.data.push(...tempResp.data.data);
        resp.data.meta.page = page + 1;
      }
      totalPages = tempResp.data.meta.totalPages;
    }
    return resp;
  } catch (err) {
    throw err;
  }
};

export const fetchListing = params => async (dispatch, getState, sdk) => {
  const { CurrentUserId } = params;
  dispatch(fetchListingDataRequest());
  let apiRes;
  return fetchUserListing(CurrentUserId)
    .then(res => {
      apiRes = res;
      const listingIds = res.data.data.map(listing => listing.id.uuid);
      return axios.get(`${apiBaseUrl()}/api/timeStatement/listings`, {
        params: { ids: listingIds, excludeBothConfirmedSide: false },
      });
    })
    .then(resp => {
      const timestatments = resp.data;
      const timestatementObj = timestatments.reduce((acc, TimeStatement) => {
        if (acc[TimeStatement.listingId] === undefined) {
          acc[TimeStatement.listingId] = [];
        }
        acc[TimeStatement.listingId].push(TimeStatement);
        return acc;
      }, {});
      apiRes.data.data.forEach(listing => {
        listing.attributes.publicData.workers = timestatementObj[listing.id.uuid];
      });
      const listingData = apiRes?.data?.data;
      apiRes?.data?.data.forEach(m =>
        dispatch(fetchListingsPaymentInfo(m.id.uuid)).then(res => {
          Object.assign(m?.attributes?.publicData, { stripeData: [res[0]] || [] });
        })
      );
      // console.log(888, listingData);
      dispatch(fetchListingDataSuccess(listingData));
    })
    .catch(error => {
      dispatch(fetchListingDataError(error));
    });
};
export const fetchListingsPaymentInfo = id => async (dispatch, getState, sdk) => {
  dispatch(workerExtraDetailsRequest());
  return axios
    .get(`${apiBaseUrl()}/api/stripe/ListingDetails`, {
      params: { listingId: id },
      withCredentials: true,
    })
    .then(res => {
      const data = res.data;
      dispatch(workerExtraDetailsSuccess());
      return data;
    })
    .catch(err => {
      const storableErr = storableError(err);
      dispatch(workerExtraDetailsError(storableErr));
      throw err;
    });
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  const CurrentUserId = fetchedcurrentUser.id.uuid;
  dispatch(fetchListing({ CurrentUserId }));
};
